module.exports = __webpack_public_path__ + "static/media/proj4.72c7bb23.jpg";